import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import PalletDetailContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/PalletDetail/PalletDetailContainer';

class invManPalletDetailView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <PalletDetailContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManPalletDetailView;
